module.exports = __webpack_public_path__ + "img/clock-ten-thirty.5b7e16bb.svg";